<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="petition-search position-absolute row bg-white ml-auto mr-auto">
    <div class="row">
      <SearchIconSVG class="mr-3 ml-3" />
      <input
        id="search"
        v-model="searchTerm"
        type="search"
        name="search"
        :placeholder="$t('action.search', locale)"
        @keyup="getFirstPage"
      />
    </div>
    <v-list
      v-if="!clear && petitions_list.length > 0"
      class="petition-search-results bg-white mt-2"
    >
      <v-list-item
        v-for="(petition, i) in petitions_list"
        :key="i"
        class="petition-result row d-flex justify-content-start mb-1"
      >
        <v-list-item-avatar
          class="mb-1 mr-2"
          :src="petition.thumbnail"
          :alt="petition.title"
          tile
          width="60px"
          height="45px"
        >
          <v-img :src="petition.thumbnail" :alt="petition.title"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <a
            :href="petition.canonical_url"
            v-html="$options.filters.highlight(petition.title, searchTerm)"
          ></a>
        </v-list-item-content>
      </v-list-item>
      <span id="results-list-end"></span>
      <AllOutSpinner v-if="loading == true" />
    </v-list>
    <div v-if="noResults" class="petition-search-results no-results mt-2">
      {{ $t('action.noResults', locale) }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AllOutSpinner from './AllOutSpinner.vue'
import SearchIconSVG from './assets/images/symbols/search-icon.svg?inline'

export default {
  name: 'PetitionSearchBox',
  components: { AllOutSpinner, SearchIconSVG },
  filters: {
    highlight: function (stringToSearch, searchTerm) {
      if (searchTerm === '') return stringToSearch
      var iQuery = new RegExp(searchTerm, 'ig')
      return stringToSearch.toString().replace(iQuery, function (matchedText, a, b) {
        return (
          "<span class='bold' style='background-color: #d9294c; color: #fff'>" +
          matchedText +
          '</span>'
        )
      })
    }
  },
  props: {
    endpoint: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      locale: document.documentElement.lang,
      clear: true,
      page: 0,
      petitions_list: [],
      searchTerm: '',
      noResults: false,
      loading: false
    }
  },
  computed: {
    ...mapState('actionForm', ['petitionsSearchResults'])
  },
  watch: {
    searchTerm() {
      if (this.searchTerm == '') {
        this.clearPages()
      }
    }
  },
  methods: {
    async getPage() {
      this.clear = false
      this.$store.commit('actionForm/SET_PETITION_ENDPOINT', this.endpoint)
      this.$store.commit('actionForm/SET_PETITION_PAGE', this.page)
      this.$store.commit('actionForm/SET_PETITION_SEARCH_TERM', this.searchTerm)
      await this.$store.dispatch('actionForm/fetchPetitionSearchResults')
      if (this.petitionsSearchResults.count == 0) {
        this.noResults = true
      } else if (this.petitionsSearchResults.results) {
        this.petitions_list.push(...this.petitionsSearchResults.results)
        this.noResults = false
        this.loading = false
        if (this.petitionsSearchResults.next) {
          this.$nextTick(() => {
            this.infiniteScroll()
          })
        }
      }
    },
    clearPages() {
      this.page = 0
      this.loading = false
      this.noResults = false
      this.clear = true
      this.petitions_list = []
      this.$store.commit('actionForm/SET_PETITION_PAGE', this.page)
      this.$store.commit('actionForm/SET_PETITION_SEARCH_TERM', this.searchTerm)
      this.$store.commit('actionForm/SET_PETITION_SEARCH_RESULTS', this.petitions_list)
    },
    getNextPage() {
      this.page++
      this.getPage()
    },
    getFirstPage() {
      this.clearPages()
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(() => {
        if (this.searchTerm && this.searchTerm != '') {
          this.petitions_list = []
          this.page = 1
          this.getPage()
        } else {
          this.clearPages()
        }
      }, 1000)
    },
    infiniteScroll() {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.clear) {
            observer.unobserve(entry.target)
            this.loading = true
            this.getNextPage()
          }
        })
      })
      const observerHtmlElement = document.getElementById('results-list-end')
      if (observerHtmlElement) {
        observer.observe(observerHtmlElement)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.petition-search {
  width: 50rem;
  border-radius: 40px;
  top: 18rem;
  left: 0;
  right: 0;
  padding: 0.5rem 3rem 0.5rem 1rem;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.22);
  z-index: 10;

  > .row {
    align-items: center;
    flex-flow: row;
  }

  button {
    font-weight: bold;
    color: var(--white);
  }

  input {
    height: 3rem;
    width: 100%;
    font-size: 20px;
  }

  img {
    width: 40px;
    height: 40px;
  }

  @media (max-width: 990px) {
    width: 90%;
    top: 17rem;
    padding: 0.5rem 2rem 0.5rem 0.5rem;
  }

  @media (max-width: 526px) {
    top: 19.5rem;
  }

  .petition-search-results {
    max-height: 20rem;
    overflow: auto;
    width: 100%;
    padding: 1.5rem;
    border-top: 1px solid #979797;

    &.no-results {
      min-height: 2rem;
    }
  }

  .petition-result {
    a {
      color: #000;
      font-weight: normal;
      font-size: 20px;
    }
  }
}
</style>
